'use client';

import { usePathname } from 'next/navigation';
import {
  Dispatch,
  FC,
  ReactNode,
  SetStateAction,
  createContext,
  useEffect,
  useState
} from 'react';

type PropsContextType = {
  isHeaderDark: boolean;
  setIsSectionScrolled: Dispatch<SetStateAction<boolean>>;
};

const initialContext = {
  isHeaderDark: false,
  setIsSectionScrolled: () => {},
};

export const HeaderContext = createContext<PropsContextType>(initialContext);

export const HeaderContextProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const pathname = usePathname();
  const [isSectionScrolled, setIsSectionScrolled] = useState(false);

  const isStockistTheme = pathname.startsWith('/themes/stockist');
  const isPromptTheme = pathname.startsWith('/themes/prompt');

  const [isHeaderDark, setIsHeaderDark] = useState(
      !isStockistTheme && !isPromptTheme &&
      ((pathname.includes('/themes/') && pathname.length > 8) || pathname === '/')
  );

  useEffect(() => {
    if (isPromptTheme) {
      setIsHeaderDark(false);
    } else if (!isStockistTheme && ((pathname.includes('/themes/') && pathname.length > 8) || pathname === '/')) {
      setIsHeaderDark(!isSectionScrolled);
    } else {
      setIsHeaderDark(false);
    }
  }, [isSectionScrolled, pathname, isStockistTheme, isPromptTheme]);

  return (
      <HeaderContext.Provider
          value={{
            isHeaderDark,
            setIsSectionScrolled,
          }}
      >
        {children}
      </HeaderContext.Provider>
  );
};
